// extracted by mini-css-extract-plugin
export var carrierTab = "_5h-0";
export var carrierTabActive = "_5h-1 _5h-0";
export var carrierTabInactive = "_5h-2 _5h-0";
export var carrierTabLabel = "_5h-3";
export var carrierTabLabelActive = "_5h-4 _5h-3";
export var carrierTabLabelInactive = "_5h-5 _5h-3";
export var carrierTabPercentage = "_5h-6";
export var carrierTabPercentageActive = "_5h-7 _5h-6";
export var carrierTabPercentageInactive = "_5h-8 _5h-6";
export var carrierTabWinnable = "_5h-9";
export var carrierTabWinnableActive = "_5h-a _5h-9";
export var carrierTabWinnableInactive = "_5h-b _5h-9";
export var comparisonContainer = "_5h-d";
export var missingRateButton = "_5h-n";
export var missingRateButtonActive = "_5h-o _5h-n";
export var missingRateButtonInactive = "_5h-p _5h-n";
export var missingRateButtonLabel = "_5h-q";
export var missingRateButtonLabelActive = "_5h-r _5h-q";
export var missingRateButtonLabelInactive = "_5h-s _5h-q";
export var sidebar = "_5h-c";
export var strategyButton = "_5h-e";
export var strategyButtonActive = "_5h-f _5h-e";
export var strategyButtonDescription = "_5h-k";
export var strategyButtonDescriptionActive = "_5h-l _5h-k";
export var strategyButtonDescriptionInactive = "_5h-m _5h-k";
export var strategyButtonInactive = "_5h-g _5h-e";
export var strategyButtonLabel = "_5h-h";
export var strategyButtonLabelActive = "_5h-i _5h-h";
export var strategyButtonLabelInactive = "_5h-j _5h-h";
export var unitToggleButton = "_5h-t";
export var unitToggleButtonActive = "_5h-u _5h-t";
export var unitToggleButtonInactive = "_5h-v _5h-t";
export var unitToggleButtonLabel = "_5h-w";
export var unitToggleButtonLabelActive = "_5h-x _5h-w";
export var unitToggleButtonLabelInactive = "_5h-y _5h-w";